let scriptLoaded = false

function loadPaystackScript() {
  return new Promise((resolve, reject) => {
    if (scriptLoaded || window.PaystackPop) {
      scriptLoaded = true
      resolve()
      return
    }
    const script = document.createElement('script')
    script.src = 'https://js.paystack.co/v1/inline.js'
    script.async = true
    script.onload = () => { scriptLoaded = true; resolve() }
    script.onerror = () => reject(new Error('Failed to load Paystack'))
    document.head.appendChild(script)
  })
}

export function usePaystack() {
  const pay = async ({ email, amount, metadata, onSuccess, onClose }) => {
    await loadPaystackScript()

    const key = import.meta.env.VITE_PAYSTACK_PUBLIC_KEY
    if (!key) throw new Error('VITE_PAYSTACK_PUBLIC_KEY is not configured')

    const ref = `msp-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`

    const handler = window.PaystackPop.setup({
      key,
      email,
      amount: Math.round(amount * 100), // pesewas
      currency: 'GHS',
      ref,
      metadata: {
        ...metadata,
        ref,
      },
      callback: (response) => onSuccess?.(response),
      onClose: () => onClose?.(),
    })

    handler.openIframe()
  }

  return { pay }
}
